export type { WindowFlagVars } from './types';
export { initialiseFeatureGates } from './statsig-initialisation';
